import { render, staticRenderFns } from "./phantom.vue?vue&type=template&id=4cb5f730&scoped=true"
import script from "./phantom.vue?vue&type=script&lang=js"
export * from "./phantom.vue?vue&type=script&lang=js"
import style0 from "./phantom.vue?vue&type=style&index=0&id=4cb5f730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb5f730",
  null
  
)

export default component.exports